module.exports = __webpack_public_path__ + "static/img/instagram.e1edeff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontend/integration_channel/instagram.png
// module id = Sf99
// module chunks = 31